import { ServerUrlService } from './server-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface BuscarPacienteOtimusBody {
  nome: string
  datanasc: string
  cpf: number
  fone: string
  telefone: string
  email: string
}

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  getAllUsuariosOtimus() {
    return this.http.get(`${this.serverUrlService.getUrl()}/usuarios/otimus`)
  }

  buscarPacienteOtimus(body: BuscarPacienteOtimusBody) {
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/pacientesotimus`, body)
  }

  atualizarUsuario(body: any) {
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/atualizarotimus`, body)
  }
}
